import { CardMedia } from '@mui/material';

const LogoName = 'kfin-logo.svg';

const logoWidth = 'unset';

export const Logo1 = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`${process.env.PUBLIC_URL}/images/${LogoName}`}
      alt=" Kfintech Logo"
      sx={{ width: logoWidth, m: 3 }}
    />
  );
};

export const LogoEditApplication = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`${process.env.PUBLIC_URL}/images/${LogoName}`}
      alt=" Kfintech Logo"
      sx={{ width: logoWidth, m: 3, mb: 2 }}
    />
  );
};

export const LogoSideBar = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`${process.env.PUBLIC_URL}/images/${LogoName}`}
      alt=" Kfintech Logo"
      sx={{ width: logoWidth }}
    />
  );
};
